import React from 'react'
import { Layout } from '../layouts/Layout';
import { Pengeluaran } from '../componen/Pengeluaran'

export const PengeluaranPages = () => {
  return (
    <Layout>
      <Pengeluaran />
    </Layout>
  )
}
